module.exports = __webpack_public_path__ + "static/img/01@2x.ae45673.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/01@2x.png
// module id = mr17
// module chunks = 1